module.exports = __webpack_public_path__ + "img/tax_assist_icon.ec3aadb3.svg";